/* unplugin-vue-components disabled */import { render } from "./TagDetails.vue?vue&type=template&id=658040bc&scoped=true"
import script from "./TagDetails.vue?vue&type=script&lang=js"
export * from "./TagDetails.vue?vue&type=script&lang=js"

import "./TagDetails.vue?vue&type=style&index=0&id=658040bc&lang=less&scoped=true"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658040bc"]])

export default __exports__